import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AdminSettingService from "../../../API/Services/AdminService/AdminSettingService";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import { SVGICON } from "../../constant/theme";

const SettingsOffCanvas = () => {
  const [settings, setSettings] = useState({});
  const [error, setError] = useState("");
  const [visibleField, setVisibleField] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("usertoken"));
    if (token) {
      getSettingData();
    } else {
      navigate("/");
    }
  }, []);

  const toggleVisibility = (key) => {
    setVisibleField((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getSettingData = async () => {
    try {
      setIsLoading(true);
      const response = await AdminSettingService.get_setting_data();
      const responseData = await response.json();
      if (responseData) {
        setSettings(responseData);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("err", error);

      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError("");
  };

  const handleSaveSetting = async (event) => {
    event.preventDefault();

    try {
      const settingData = Object.keys(settings || {}).reduce((acc, key) => {
        acc[key] = settings[key];
        return acc;
      }, {});

      const data = await AdminSettingService.store(settingData).json();

      if (data.status) {
        swal("Setting updated Successfully").then((ok) => {
          if (ok) {
            getSettingData();
          }
        });
      }
    } catch (error) {
      if (error.status === 422) {
        setError(error.message);
        // setError({
        //   stripe_secret_key: 'Stripe Secret Key must start with "sk_"',
        //   stripe_publishable_key: 'Stripe Secret Key must start with "pk_"',
        // });
      }
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="container mt-5">
              <h2>Settings</h2>
              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center mb-5 mt-5">
                  <ClipLoader color="#4474fc" />
                </div>
              ) : (
                <form onSubmit={handleSaveSetting}>
                  <div className="row">
                    {Object.keys(settings).map((key) => (
                      <div className="col-md-6 mt-3" key={key}>
                        <label className="form-label text-capitalize">
                          {key.replaceAll("_", " ")}
                        </label>

                        <div className="position-relative">
                          <input
                            type={
                              key === "stripe_secret_key"
                                ? visibleField[key]
                                  ? "text"
                                  : "password"
                                : "text"
                            }
                            name={key}
                            value={settings[key] || ""}
                            onChange={handleChange}
                            className={`form-control`}
                          />

                          {key === "stripe_secret_key" && (
                            <span
                              onClick={() => toggleVisibility(key)}
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {visibleField[key] ? SVGICON.eye : SVGICON.eyeOff}
                            </span>
                          )}
                        </div>
                        {/* {error[key] && (
                          <p className="text-danger fs-12 mt-2 ">
                            {error[key]}
                          </p>
                        )} */}
                      </div>
                    ))}
                  </div>
                  {error && (
                    <p className="text-danger fs-12 mt-2 text-center">
                      {error}
                    </p>
                  )}
                  <div className="row mt-4">
                    <div className="d-flex justify-content-center">
                      <Button type="submit" className="btn btn-primary px-4">
                        Submit
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsOffCanvas;
